import type { TextExpanderEvents } from '@otto-ec/global-pattern';
import { Component } from '../component';
import { ImageLoadWatcher } from './image-load-watcher';

export class Wallpaper extends Component {
    private wallpaperElement: HTMLElement | null = null;
    private isInitialVariationChange = true;

    private addTextExpanderToggledListener() {
        window.o_global.events<TextExpanderEvents>().on('assets.textExpander.toggled', (event) => {
            if (event.target === this.wallpaperElement) {
                this.trackEvent({
                    product_RichContent: event.isOpen ? ['more'] : ['less'],
                });
            }

            if (!event.isOpen) {
                this.wallpaperElement?.scrollIntoView();
            }
        });
    }

    public variationChanged() {
        this.wallpaperElement = document.querySelector<HTMLElement>('.js_rc_wallpaper');
        if (!this.wallpaperElement) return;

        if (this.isInitialVariationChange) {
            this.addTextExpanderToggledListener();
            this.isInitialVariationChange = false;
        }

        const imageElements = this.wallpaperElement.querySelectorAll<HTMLImageElement>('.js_rc_wallpaper__img');
        ImageLoadWatcher.waitForAllImagesToBeLoaded(imageElements).then(() => {
            if (!this.wallpaperElement) return;

            window.o_global.events<TextExpanderEvents>().emit('assets.textExpander.init', '.js_rc_wallpaper');

            this.trackView({
                product_RichContent: this.wallpaperElement.clientHeight >= 3200 ? ['foldable'] : ['not_foldable'],
            });
        });
    }
}
